<template>
  <div style="width: 800px;
    margin: 30px auto;">
    <div class="wholeBox" v-loading="loading">
        <div class="infoBox">
            <span>收货地址 <el-divider direction="vertical"></el-divider>
<!--              大型商品下单后，收货地址将无法修改。-->
            </span>
<!--            <span class="textRedColor">-->
<!--              快递公司会电话联系您确认送货时间，收货时需核对身份证信息。-->
<!--            </span>-->
        </div>
        <div class="getaddressList">
            <el-row>
                    <div >
                        <el-col  :class="auctionBxmObj?'isActive getaddressItem':'getaddressItem'">
                           <div >
                                <p><strong>姓名: </strong> {{auctionBxmObj.recipient}}</p>
                                <p><strong>电话: </strong> {{auctionBxmObj.phoneNumber}}</p>
                                <p class="twoLineDisplay"><strong>地址: </strong> {{auctionBxmObj.region}} &nbsp; <span>{{auctionBxmObj.shipAddress}}</span></p>
                                <div class="addressColor">
                                    <span @click="editAddress(auctionBxmObj)" class="edit">修改</span>
                                    <!-- <span @click="deleteAddress(item.said)" class="delete">删除</span> -->
                                </div>
                            </div>
                        </el-col>
                    </div>

            </el-row>

        </div>
    </div>



    <!-- 地址的弹框 -->
    <el-dialog
        :visible.sync="dialogVisible"
        :destroy-on-close='true'
        :close-on-click-modal="false"
        @close ='beforeClose'
        width="30%"
        class="dialogBox">
        <div v-show="showEditButtom?false:true" class="textCenter">添加收货地址</div>
        <div v-show="showEditButtom?true:false" class="textCenter">编辑收货地址</div>
        <span slot="footer" class="dialog-footer">
            <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">

                <el-form-item label="收件人" prop="recipient">
                    <el-input type="text" v-model="ruleForm.recipient" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phoneNumber">
                    <el-input type="text" v-model="ruleForm.phoneNumber" autocomplete="off"></el-input>
                </el-form-item>
                <!-- 修改地址时展示 -->
                <el-form-item label="地址" prop="areaid" v-show="showEditButtom?true:false">
                   <div class="addressCss"  v-if="areaName">
                        <span>{{areaName}}</span><span class="editCss" @click="isShowAddress">修改地址</span>
                   </div>
                    <!-- <el-input type="text" v-model="ruleForm.areaid" autocomplete="off"></el-input> -->
                    <el-cascader
                        v-else
                        v-model="cascaderAreaValue"
                        ref="cascaderAddr"
                        class="cascaderArea"
                        placeholder="请选择收货地址"
                        :props="{ checkStrictly: true }"
                        :options="getprovince"
                        @change="areaHandleChange">
                    </el-cascader>
                </el-form-item>
                <el-form-item label="详细地址" prop="address">
                    <el-input v-model="ruleForm.address"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" :disabled='comfiremdisabled' v-show="showEditButtom?false:true" @click="submintAddress()" class="buttonBgd">确 定</el-button>
                    <el-button type="primary" v-show="showEditButtom?true:false" @click="submintAddress('edit')" class="buttonBgd">确 定 修 改</el-button>
                </el-form-item>
                </el-form>
        </span>
    </el-dialog>

  </div>
</template>
<script>
import { immediatePlaceOrder,shoppingCartlist,getAuctionDetail,addresslist,address_add,address_remove,address_saveedit,getStoreFreight,coveragePrice,getBxmInfo,updateBxmInfo} from '@/api/xunyou'
import {mapState} from 'vuex'
export default {
  data() {
    return {
        onlineOrOffline: 1, // 1:在线 2:线下
        shopGoodsObj: [],
        visible:false,
        userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
        isSelectedAddress:'',
        loading:false,
        showEditButtom:false,
        dialogVisible:false,
        payDialogVisible: false,
        selected:false,
        openradio:1,
        invoiceAddressValue:'',//收票人地址
        seeMoreCommonProblem:false, // 更多常见问题弹框
        cascaderAreaValue:[],
        auctionBxmObj: '', // 对象
        ruleForm:{
            muid:JSON.parse(localStorage.getItem("userdata")).userId,
            recipient:'',
            phoneNumber:'',
            areaid:'',
            address:'',
            postalCode:'',
            defaultAddress:0,
            id: '',
        },
        redPackmoney:'',
        showpopover:'',
        rules:{
            recipient: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            phoneNumber: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            areaid: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            address: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            // postalCode: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            registerAddress: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            registerphone: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            bank: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            bankNumber: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            invoiceName: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            invoiceAddressValue: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            invoiceAddressDetail: [{ required: true, message: "不能为空,请输入", trigger: ["blur", "change"] },],
            invoicePhone: [{
                required: true,
                trigger: ["blur", "change"],
                validator:(rule, value, callback) => {
                        if (this.invoiceType != 3 && value=='') {
                          callback(new Error('不能为空,请输入'));
                        }else if(!/^[1][3,4,5,7,8][0-9]{9}$/.test(value)){
                            callback(new Error('请输入11位手机号'));
                        }else{
                          callback();
                        }
                      }
                },],
            headerName: [{ required: true,
             trigger: ["blur"] ,
             validator:(rule, value, callback) => {
                        if (this.groupType == 1 && value=='') {
                          callback(new Error('不能为空,请输入'));
                        }else if(this.groupType == 2 && value==''){
                            callback(new Error('不能为空,请输入'));
                        }
                        else{
                          callback();
                        }
                      }
            }],
            taxNumber: [{ required: true,
                trigger: ["blur"],
                validator:(rule, value, callback) => {
                        if (this.groupType == 2 && value=='') {
                          callback(new Error('不能为空,请输入'));
                        }else{
                          callback();
                        }
                      }

             }],
        },
        addressLists:[],
        scidArr:[],
        payMoney: '', // 应付总额
        payMethodsCheckbox: 1, // 支付方式 在线支付/线下打款
        selectedAddressId:'', // 选择的收货地址id
        addressitemObj:{},// 选中的地址对象
        buyNow:false, // 是否是从立即购买按钮跳转过来的
        areaName:'',
        comfiremdisabled:false,
        isDisabled:false,
        totalOrderNos:[]
    };
  },
  // 注册组件
  components: {},
    computed:{
    ...mapState(['getprovince'])
  },
  /**
   * 数据发生改变
   */

  mounted(){
      this.getBxmInfo()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    change1() {
      this.$forceUpdate()
    },
    isShowAddress(){
        this.areaName = ''
    },
    //  个人信息加密
    encryption(str, len) {
      if (str.length <= len) {
        return str;
      } else {
        var newStr = str.substring(0, 3);
        var newStrs = str.substring(str.length , str.length - 4);
        newStr = newStr + "****" + newStrs;
        return newStr;
      }
    },

    //   选择收货地址
    selectedAddress(index,selectedAddressId,itemObj){
            this.addressitemObj = itemObj
            this.selected = true;
            this.isSelectedAddress = index;
            this.selectedAddressId = selectedAddressId
            let storesList = []
            this.shopGoodsObj.forEach((item)=>{
                let goodsList = []
                item.goodsList.forEach((goodsItem)=>{
                    let goods = {}
                    if(!goodsItem.activity){ // 只查主商品的运费
                        goods = {
                            id: goodsItem.id,
                            number: goodsItem.number,
                            specId: goodsItem.bxysid,
                        }
                        goodsList.push(goods)
                    }
                })
                let obj = {}
                obj = {
                    bxmId:item.bxmId,
                    goodsList:goodsList
                }
                storesList.push(obj)
            })
            const req = {
                said:this.selectedAddressId, // 收货地址
                storesList:storesList // 店铺信息
            }
            if(this.selectedAddressId){
                // 调修改运费接口
                getStoreFreight(req)
                .then(res => {
                if (res.data.code == 0) {
                    this.storeFreightList = res.data.data
                } else {
                    this.$message({
                    type: 'info',
                    message: res.msg
                    })
                }
                })
                .catch(err => {
                this.$message.error('查询运费失败，请稍后再试！')
                })
            }
    },
    // 填写地址选择
    areaHandleChange(value){
      const nodes = this.$refs['cascaderAddr'].getCheckedNodes()
      this.ruleForm.areaid = value[value.length-1]
      if (nodes && nodes.length > 0) {
        // 提取省市区的名称
        const selectedNodes = nodes[0].pathLabels;
        this.ruleForm.region = selectedNodes.join('/'); // 将省市区名称组装成region格式
      }
    },
    // 获取详情
    getBxmInfo() {
      this.loading = true
      var uid = JSON.parse(localStorage.getItem("userdata")).userId || {}
      getBxmInfo({uid: uid}).then(res => {
        if(res.code === 0){
          this.loading = false
          this.auctionBxmObj = res.data
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
        .catch(err => {
          console.log('getAuctionDetail fail', err)
          this.loading = false
          this.$message.error('查询失败，请稍后再试！')
        })
    },
      // 添加地址
      addAddress(){
          this.payDialogVisible= true
      },
    //   关闭弹框清空
      beforeClose(){
          this.ruleForm = {}
          this.cascaderAreaValue = []
          this.showEditButtom = false
      },
    //   新增收货地址
      submintAddress(item){
        //   console.log(editReq,'xiugai1')
          if(item == 'edit'){
              this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                     let editReq = {
                        muid:this.ruleForm.muid,
                        said:this.ruleForm.said,
                        recipient:this.ruleForm.recipient ,
                        phoneNumber:this.ruleForm.phoneNumber ,
                        areaid:this.ruleForm.areaid ,
                        shipAddress:this.ruleForm.address,
                        region:this.ruleForm.region,
                        id: this.ruleForm.id
                    }
                    console.log(editReq,'xiugai2')
                  updateBxmInfo(editReq)
                        .then(res => {
                        if (res.code == 0) {
                            this.showEditButtom = false
                            this.dialogVisible= false
                            this.ruleForm = {}
                            this.cascaderAreaValue=[]
                            this.getBxmInfo()
                        } else {
                            this.$message({
                            type: 'info',
                            message: res.msg
                            })
                        }
                        })
                        .catch(err => {
                        this.dialogVisible= false
                        this.$message.error('修改失败，请稍后再试！')
                        })
                    }
                });
          }else{
              this.$refs.ruleForm.validate((valid) => {
                  this.ruleForm.muid = this.userInfo.userId,
                   this.ruleForm.defaultAddress=this.ruleForm.defaultAddress?1:0
                if (valid) {
                    this.comfiremdisabled = true
                    address_add(this.ruleForm)
                        .then(res => {
                        if (res.code == 0) {
                            this.dialogVisible= false
                            this.comfiremdisabled = false
                            this.ruleForm = {}
                            this.getaddresslist()
                        } else {
                            this.$message({
                            type: 'info',
                            message: res.msg
                            })
                            this.comfiremdisabled = false
                        }
                        })
                        .catch(err => {
                        this.dialogVisible= false
                        this.$message.error('提交失败，请稍后再试！')
                        })
                    }
                });
          }
      },

    // 修改地址
    editAddress(item){
        console.log(item,'选择的每一项地址')
        this.areaName = item.region
        this.dialogVisible = true
        this.showEditButtom = true
        this.ruleForm = {
            muid:item.muid,
            said :item.said,
            recipient:item.recipient,
            phoneNumber:item.phoneNumber,
            areaid:item.areaid,
            address:item.shipAddress,
            id: item.id
        }
      // 如果有省市区信息，可以进一步拆分
      if (item.region) {
        this.cascaderAreaValue = item.region.split('/'); // 假设region格式为"省/市/区"
      }
    },
    // 地址查询
      getaddresslist() {
          this.loading = true
         addresslist({muid:this.userInfo.userId})
            .then(res => {
              if (res.code == 0) {
                  this.loading = false
                  if(res.rows.length>0){
                      this.addressLists = res.rows
                      if(this.addressLists.length>0){
                           this.addressLists.forEach((item,index)=>{
                            if(item.defaultAddress){
                                this.isSelectedAddress = index+1
                                this.addressitemObj = item
                                this.selected = true;
                                this.selectedAddressId = item.said
                                this.selectedAddress(this.isSelectedAddress,this.selectedAddressId,item)
                            }
                        })
                        let defaultAddressList =  this.addressLists.filter(item=>item.defaultAddress!=0)
                        if(defaultAddressList.length==0&&this.addressLists.length>0){
                            this.selected = true
                            this.isSelectedAddress = 1
                            this.selectedAddressId = this.addressLists[0].said
                            this.selectedAddress(1,this.selectedAddressId,this.addressLists[0])
                        }
                      }else{
                          this.selectedAddressId = ''
                      }
                  }else{
                      this.addressLists = []
                  }
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
    },

  },
};
</script>

<style scoped lang="less">
.wholeBox{
    padding:30px 30px 10px 30px;
    background: white;
    .isActive{
        border: 1px solid #78b942 !important;
        background: #f1f6fd;
    }
    .infoBox{
        .textRedColor{
            color:#78b942;
        }
    }
    .getaddressList{
        margin: 20px 0;
        display: flex;
        justify-content: flex-start;
        .addHover{
            padding: 63px 30px !important;
        }
        .addHover:hover{
            cursor: pointer;
            color:#78b942;
        }
        .defaultAddressColor{
            color: #78b942;
            position: absolute;
        }
        .getaddressItem{
            border: 1px solid #ccc;
            display: inline-block;
            padding: 30px;
            box-sizing: border-box;
            margin-right: 20px;
            width: 240px;
            cursor: pointer;
            margin-bottom: 10px;
            min-height: 208px;
            .addIcon{
                font-size: 30px;
                text-align: center;
                display: block;
                margin-bottom: 10px;
                margin-top: 15px;
            }
            p{
                line-height: 25px;
            }
            .addressColor{
                text-align: right;
                position: relative;
                bottom: -20px;
                color: #78b942;
                cursor: pointer;
                font-size: 14px;
                line-height: 14px;
                span{
                    display: inline-block;
                    margin-left: 15px;
                  .edit{
                    padding-top: 1px;
                  }
                }

                .delete{
                    /deep/button.el-button.el-button--default.el-popover__reference {
                        border: 0px;
                        color: #78b942;
                        padding: 0;
                    }
                    /deep/.el-button:focus, .el-button:hover{
                        background: transparent;
                    }

                }
            }
        }
    }

}

.wholeRedBox {
  display: flex;
  justify-content: flex-start;
  width: 190px;
  height: 100px;
  border: 1px solid #eaeaea;
  margin-bottom: 10px;
  padding: 10px;
  box-sizing: border-box;
  cursor: pointer;
  .img-responsive {
    width: 60px;
    height: 60px;
    text-align: center;
    top: 10%;
    position: relative;
    }
.text_right{
    margin-left: 10px;
}
button.el-button.buttonBgd.el-button--primary {
    color: #fff;
    background-color: #78b942;
    border-color: #e65d00;
    width: 180px;
    margin-left: 12px;
    margin-top: 5px;
    font-size: 14px;
}
.getNow {
  margin-top: 1px;
  background-color: #d93600;
  padding: 7px 15px;
  font-size: 15px;
  color: white;
}
//   .el-button--text.is-disabled {
//       color: #e4e7ed;
//       background-color: #999;
//   }
}
.payMethodsNew{
  /deep/.el-radio-button__orig-radio+.el-radio-button__inner {
    background: transparent;
    line-height: 0;
  }
  /deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner {
    border-color: #78b942;
    color: #78b942;
    background: transparent;
    line-height: 0;
  }
}
.orderBox{
    padding: 0 27px;
    background: white;
    .payMethods{
        padding: 30px !important;
        background: white !important;
        border-bottom: 1px solid #ccc !important;
        /deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner {
            border-color: #78b942;
            color: #78b942;
            background: transparent;
            line-height: 0px;
        }
        .invoiceBox{
            margin: 10px;
            .el-radio-group{
                display: block;
                margin: 25px 0;
                /deep/.el-radio-button__inner{
                    width: 160px;
                    line-height: 0px;
                }
            }
            .more{
                font-size: 14px;
                .active{
                    color: #78b942;
                    a{
                       color: #78b942 !important;
                    }
                }
            }
        }

    }
/deep/.el-row.payMethods {
            // line-height: 40px;
            font-size: 18px;
        }
    .orderDetailText {
        display: flex;
        justify-content: space-between;
        padding: 0 0 5px 27px;
        background: white;
        font-size: 18px;
        a{
            color: #b0b0b0;
        }
    }
  .scroll-container {
    height: 200px; /* 设置固定高度 */
    overflow-y: auto; /* 启用垂直滚动条 */
}
    .order_Info{
        font-size: 14px;
        .el-image{
            height: 30px;
            width: 30px;
        }
        .order_Info_item{
            line-height: 40px;
        }
        span.addIcon {
            background: #78b942;
            color: white;
            font-size: 12px;
            margin-left: 10px;
            padding: 2px 5px;
            box-sizing: border-box;
            border-radius: 4px;
        }
    }
    .order_detailInfo{
        padding: 10px 27px;
        // border-bottom: 1px solid #ccc;
        border-top: 1px solid #ccc;
        font-size: 14px;
        background: white;
        .nodate {
            text-align: center;
            margin: 70px;
            font-size: 16px;
        }
        .order_detailInfo_price{
            padding: 0 60px;
            color: #78b942;
            span.addIcon {
                background: #78b942;
                color: white;
                font-size: 12px;
                margin-left: 10px;
                padding: 2px 8px;
                box-sizing: border-box;
                border-radius: 4px;
            }
        }
    }
    .Fee_Dtails{
        font-size: 14px;
        padding: 27px 0 27px 27px;
        background: white;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        display: flex;
        justify-content: space-between;

        .Fee_Dtails_add{
            i.el-icon-circle-plus {
                color: #ff9a00;
                font-size: 30px;
                vertical-align: middle;
                cursor: pointer;
            }
            .use_red{
               text-align: center;
               p{
                   font-size: 18px;
                   color: #757575;
                   text-align: left;
                   padding: 0 20px;
                   box-sizing: border-box;
               }

               div {
                //    height: 180px;
                //    line-height: 180px;
               }
            }
            .envelopeListBox{
                /deep/.el-popover{
                    width: 800px;
                }
            }

        }
        .order_Info_item{
            line-height: 30px;
            color: #757575;
        }
        .Fee_Dtails_money{
            text-align: right;
            .order_Info_item{
                color: #78b942 !important;
            }
        }
        .Fee_Dtails_info{
            display: flex;
            .Fee_Dtails_item.el-row {
                text-align: right;
            }
        }

    }
    .order_detailInfo .Fee_Dtails:last-child{
        border-bottom: 0px;
    }
    .total_price{
        font-size: 25px;
        text-align: right;
        margin: 0 0 20px 0;
        // border-bottom: 1px solid #ccc;
        background: white;
        .total_price_color{
            color: #78b942;
            font-weight: bold;
        }
    }

}
 button.el-button.buttonBgd.el-button--primary {
        background-color: #78b942;
        border-color: #78b942;
        font-size: 14px;
        margin-bottom: 20px;
    }
.cascaderArea.el-cascader {
    width: 100%;
    /deep/input[disabled], /deep/input[disabled="disabled"], /deep/input[readonly], /deep/input[readonly="readonly"] {
    background-color: white;
}
}
.seeMoreCommonProblemBox{

    /deep/.el-dialog__body{
        text-align: center !important;
        .modalContent{
            text-align: left;
            padding-bottom: 20px;
        }
    }
}
.addressCss{
    display: flex;
    justify-content: space-between;
    .editCss{
        color: #78b942;
        cursor: pointer;
    }
}

</style>







// WEBPACK FOOTER //
// src/views/auction/auctionBxm.vue